import Dropdown, { DropdownItem } from "@gfg/ui-v2/components/dropdown";

export interface AvailableOption<T> {
  label: string;
  value: T;
}

interface DropdownActionButtonProps {
  options: AvailableOption<string>[];
  triggerElement: React.ReactElement;

  onOptionClick(value: string): void;
}

export default function DropdownActionButton({ options, triggerElement, onOptionClick }: DropdownActionButtonProps) {
  return (
    <Dropdown triggerElement={triggerElement} onSelect={onOptionClick}>
      {options.map(({ label, value }) => (
        <DropdownItem key={value} value={value}>
          {label}
        </DropdownItem>
      ))}
    </Dropdown>
  );
}
